import React from 'react';
import { isEmpty } from 'lodash';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { bool, func, object, string, number, arrayOf } from 'prop-types';
import { getLastReviewDetails, getPackageEntryClassNames } from '../../utils';
import * as actions from '../../store/actions';
import { ReviewsContext } from '../shared/context';
import Filters from '../shared/Filters';
import Header from '../shared/Header';
import NoReviews from '../shared/NoReviews';
import LoadMoreBtn from '../shared/LoadMoreBtn';
import ReviewsList from './ReviewsList';

import './styles.scss';

class Index extends React.Component {
    constructor() {
        super();

        this.reviewsRef = React.createRef();
    }

    static contextType = ReviewsContext;

    displayReviewsList() {
        const { reviews } = this.props;
        return !isEmpty(reviews);
    }

    displayVerified() {
        const { displayVerified } = this.props;
        return displayVerified && this.displayReviewsList();
    }

    render() {
        const {
            userName,
            selfView,
            isBuyerProfile,
            reviews,
            type,
            fetchReviews,
            pathFinderConfig,
            onFilterChange,
            onLoadMoreClick,
            ignoredReviewIds,
            hasNext,
        } = this.props;

        const lastReview = getLastReviewDetails({ reviews, ignoredReviewIds, type });

        const headerProps = {
            fetchReviews,
            onFilterChange,
            lastReview,
            isBuyerProfile,
            displayVerified: this.displayVerified(),
        };

        const showReviewsList = this.displayReviewsList();
        const packageClass = getPackageEntryClassNames();

        return (
            <div className={packageClass}>
                <Header {...headerProps} />
                <Filters fetchReviews={fetchReviews} headerProps={headerProps} />
                {showReviewsList && (
                    <div className={classnames({ 'reviews-wrap': !isBuyerProfile })} ref={this.reviewsRef}>
                        <ReviewsList reviews={reviews} />

                        {hasNext && (
                            <LoadMoreBtn
                                fetchReviews={fetchReviews}
                                onLoadMoreClick={onLoadMoreClick}
                                type={type}
                                lastReviewDetails={lastReview}
                                pathFinderConfig={pathFinderConfig}
                            />
                        )}
                    </div>
                )}

                {!showReviewsList && (
                    <NoReviews type={type} selfView={selfView} isBuyerProfile={isBuyerProfile} userName={userName} />
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    reviews: state.stars || state.reviews,
    averageValuation: state.average_valuation,
    starSummary: state.star_summary,
    totalCount: state.total_count,
    type: state.type,
    pathFinderConfig: state.pathFinderConfig,
    displayVerified: state.displayVerified,
    displayBreakdown: state.displayBreakdown,
    displayLocation: state.displayLocation,
    breakdown: state.breakdown,
    ignoredReviewIds: state.ignored_review_ids,
    hasNext: state.has_next,
});

const mapDispatchToProps = (dispatch) => bindActionCreators(actions, dispatch);

Index.defaultProps = {
    totalCount: 0,
    breakdown: null,
};

Index.propTypes = {
    reviews: arrayOf(object),
    averageValuation: number,
    starSummary: object,
    totalCount: number,
    type: string,
    pathFinderConfig: object,
    onFilterChange: func,
    onLoadMoreClick: func,
    displayVerified: bool,
    breakdown: arrayOf(object),
    displayBreakdown: bool,
    displayLocation: bool,
    hasNext: bool,
    selfView: bool,
    isBuyerProfile: bool,
    userName: string,
};

export default connect(mapStateToProps, mapDispatchToProps)(Index);
